import type { GlobalVariableKey } from './global-variables-types/global-variable-key';
import type { GlobalVariableValue } from './global-variables-types/global-variant-value';

const globalVariables = new Map<GlobalVariableKey, GlobalVariableValue>([
  ['showSandboxDialog', false],
]);

type Listener = (key: GlobalVariableKey, value: GlobalVariableValue) => void;
const listeners = new Set<Listener>();

export const setGlobalVariable = (key: GlobalVariableKey, value: GlobalVariableValue) => {
  globalVariables.set(key, value);
  listeners.forEach(listener => listener(key, value));
};

export const getGlobalVariable = (key: GlobalVariableKey) => globalVariables.get(key);

export const subscribeToGlobalVariable = (listener: Listener) => {
  listeners.add(listener);

  return () => listeners.delete(listener);
};